<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="tags"
      :items-per-page="10"
      :sort-by="['id']"
      sort-desc
    >
      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="editItem(item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-account-edit</v-icon>
              {{ $t('ITEM.EDIT') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>

    <v-dialog
      v-if="dialogEdit"
      v-model="dialogEdit"
      persistent
      max-width="400px"
    >
      <item-edit-page
        :item-edit="tag"
        :languages="languages"
        @cancel="dialogEdit = !dialogEdit"
        @success="editedItem"
      ></item-edit-page>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'TagList',

  components: {
    ItemEditPage: () => import('@/modules/tags/pages/TagEditPage')
  },

  props: {
    tags: {
      type: Array,
      required: true
    },
    languages: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    tag: null,
    dialogEdit: false,
    dialogDelete: false,

    headersDynamic: []
  }),

  computed: {
    headers() {
      return this.headersDynamic;
    }
  },

  created() {
    this.headersDynamic.push({
      text: this.$t('ITEM.ID'),
      align: 'left',
      sortable: true,
      value: 'id'
    });

    this.languages.forEach(language => {
      this.headersDynamic.push({
        text: language.name,
        value: language.locale
      });
    });

    this.headersDynamic.push({ text: '', value: 'action', align: 'center' });
  },

  methods: {
    editItem(item) {
      this.tag = item;
      this.dialogEdit = !this.dialogEdit;
    },

    editedItem() {
      this.$emit('refresh-items');
      this.dialogEdit = !this.dialogEdit;
    },

    deleteItem(item) {
      this.tag = item;
      this.dialogDelete = !this.dialogDelete;
    },

    deletedItem() {
      this.$emit('refresh-items');
      this.dialogDelete = !this.dialogDelete;
    }
  }
};
</script>
